/* TypeScript DTOs for News and Communications API */

/** Computed status based on publishedAtUtc and expiresAtUtc */
export type NewsItemStatus = 'Draft' | 'Published' | 'Expired';

/** Helper to compute status from dates */
export function getNewsItemStatus(publishedAtUtc: string | null | undefined, expiresAtUtc: string | null | undefined): NewsItemStatus {
  if (!publishedAtUtc) return 'Draft';
  if (expiresAtUtc && new Date(expiresAtUtc) < new Date()) return 'Expired';
  return 'Published';
}

export interface NewsItemDto {
  id: number;
  title: string;
  content: string;
  summary: string;
  imageUrl?: string | null;
  franchiseId: number;
  storeNumbers?: string[] | null;
  isGlobal: boolean;
  isPinned: boolean;
  publishedAtUtc?: string | null;
  visibleFromUtc?: string | null;
  expiresAtUtc?: string | null;
  createdAtUtc: string;
  createdByUserId: number;
  createdByUserName: string;
  updatedAtUtc?: string | null;
  updatedByUserId?: number | null;
  updatedByUserName?: string | null;
  viewCount: number;
  likeCount: number;
  commentCount: number;
  tags?: number[] | null;
}

export interface NewsCommentDto {
  id: number;
  newsItemId: number;
  content: string;
  createdAtUtc: string;
  createdByUserId: number;
  createdByUserName: string;
  parentCommentId?: number | null;
  likeCount: number;
  isEdited: boolean;
}

export interface NewsEngagementSummaryDto {
  newsItemId: number;
  viewCount: number;
  likeCount: number;
  commentCount: number;
  uniqueViewers: number;
  engagementRate: number;
}

export interface CreateUpdateNewsItemDto {
  title: string;
  content: string;
  summary: string;
  imageUrl?: string | null;
  franchiseId: number;
  storeNumbers?: string[] | null;
  isGlobal: boolean;
  isPinned: boolean;
  publishedAtUtc?: string | null;
  visibleFromUtc?: string | null;
  expiresAtUtc?: string | null;
  tags?: number[] | null;
}

export interface NewsTagDto {
  id: number;
  name: string;
  description?: string | null;
  color?: string | null;
  isActive: boolean;
  usageCount: number;
  createdAtUtc: string;
  updatedAtUtc?: string | null;
}

export interface CreateUpdateNewsTagDto {
  name: string;
  description?: string | null;
  color?: string | null;
  isActive: boolean;
}
